export default __webpack_public_path__ + "static/media/clio-rs-colour-2.634545ad.jpg";